<template>
  <header class="workbench-topbar">
    <div class="topbar-left">
      <span class="page-title">降重降AI</span>
    </div>
    <div class="topbar-right">
      <template v-if="loggedIn">
        <button type="button" class="promo-hot-btn" @click="openWechatContactPromo">
          <span class="promo-fire" aria-hidden="true">🔥</span>
          <span class="promo-hot-text">{{ wechatContactPromoLabel }}</span>
        </button>
        <button type="button" class="text-btn redeem-btn" @click="$emit('redeem')">
          <i class="bi bi-gift"></i> 兑换码
        </button>
        <button type="button" class="icon-btn" aria-label="消息通知" @click="$emit('notify')">
          <i class="bi bi-bell"></i>
          <span v-if="unreadCount" class="badge-dot">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
        </button>

        <div ref="userMenu" class="user-menu">
          <button type="button" class="user-trigger" @click="toggleMenu">
            <span class="avatar-wrap">
              <img v-if="avatarUrl" :src="avatarUrl" alt="" class="avatar-img" />
              <span v-else class="avatar-fallback">{{ avatarText }}</span>
            </span>
            <span class="user-nick">{{ displayNick }}</span>
            <i class="bi bi-chevron-down chevron" :class="{ open: menuOpen }"></i>
          </button>
          <transition name="menu-fade">
            <div v-if="menuOpen" class="dropdown-panel">
              <button type="button" class="menu-item" @click="handleMenu('redeem')">
                <i class="bi bi-gift"></i>兑换码
              </button>
              <button type="button" class="menu-item" @click="handleMenu('profile')">
                <i class="bi bi-person"></i>个人资料
              </button>
              <button type="button" class="menu-item" @click="handleMenu('messages')">
                <i class="bi bi-envelope"></i>
                <span class="menu-item-text">我的私信</span>
                <span v-if="messageUnreadCount" class="menu-badge">{{ messageUnreadCount > 9 ? '9+' : messageUnreadCount }}</span>
              </button>
              <button type="button" class="menu-item" @click="handleMenu('faq')">
                <i class="bi bi-question-circle"></i>常见问题
              </button>
              <button type="button" class="menu-item" @click="handleMenu('feedback')">
                <i class="bi bi-chat-left-text"></i>问题反馈
              </button>
              <button type="button" class="menu-item" @click="handleMenu('about')">
                <i class="bi bi-info-circle"></i>关于我们
              </button>
              <div class="menu-divider"></div>
              <button type="button" class="menu-item danger" @click="handleMenu('logout')">
                <i class="bi bi-box-arrow-right"></i>退出登录
              </button>
            </div>
          </transition>
        </div>
      </template>
      <template v-else>
        <button type="button" class="btn-primary small" @click="$emit('login')">登录</button>
      </template>
    </div>

    <WechatContactPromoModal :visible="contactPromoVisible" @close="contactPromoVisible = false" />
  </header>
</template>

<script>
import WechatContactPromoModal from '@/components/workbench/WechatContactPromoModal.vue'
import { WECHAT_CONTACT_PROMO } from '@/constants/marketingWechatContact'
import {
  openUserProfile,
  openUserFaq,
  openUserFeedback,
  openUserAbout,
  openUserMessages,
  onMessageUnreadChanged,
  offMessageUnreadChanged
} from '@/utils/userMenu'
import { onLoginSuccess, offLoginSuccess } from '@/utils/loginModal'
import { getUnreadMessageCount } from '@/api/portal/message'

export default {
  name: 'WorkbenchTopbar',
  components: { WechatContactPromoModal },
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    },
    nickName: {
      type: String,
      default: '访客'
    },
    avatar: {
      type: String,
      default: ''
    },
    unreadCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      menuOpen: false,
      messageUnreadCount: 0,
      contactPromoVisible: false,
      wechatContactPromoLabel: WECHAT_CONTACT_PROMO.label
    }
  },
  watch: {
    loggedIn(val) {
      if (val) {
        this.refreshMessageUnread()
      } else {
        this.messageUnreadCount = 0
      }
    }
  },
  computed: {
    displayNick() {
      return this.nickName || '用户'
    },
    avatarUrl() {
      return (this.avatar || '').trim()
    },
    avatarText() {
      return this.displayNick.charAt(0).toUpperCase()
    }
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick)
    onLoginSuccess(this.refreshMessageUnread)
    onMessageUnreadChanged(this.refreshMessageUnread)
    if (this.loggedIn) {
      this.refreshMessageUnread()
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick)
    offLoginSuccess(this.refreshMessageUnread)
    offMessageUnreadChanged(this.refreshMessageUnread)
  },
  methods: {
    refreshMessageUnread() {
      if (!this.loggedIn) {
        this.messageUnreadCount = 0
        return
      }
      getUnreadMessageCount()
        .then(res => {
          this.messageUnreadCount = Number(res.data) || 0
        })
        .catch(() => {
          this.messageUnreadCount = 0
        })
    },
    openWechatContactPromo() {
      if (!this.loggedIn) {
        this.$emit('login')
        return
      }
      this.contactPromoVisible = true
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    },
    onDocumentClick(e) {
      if (!this.menuOpen) {
        return
      }
      const root = this.$refs.userMenu
      if (root && !root.contains(e.target)) {
        this.closeMenu()
      }
    },
    handleMenu(action) {
      this.closeMenu()
      if (action === 'profile') {
        openUserProfile()
        return
      }
      if (action === 'redeem') {
        this.$emit('redeem')
        return
      }
      if (action === 'messages') {
        openUserMessages()
        return
      }
      if (action === 'faq') {
        openUserFaq()
        return
      }
      if (action === 'feedback') {
        openUserFeedback()
        return
      }
      if (action === 'about') {
        openUserAbout()
        return
      }
      if (action === 'logout') {
        this.$emit('logout')
      }
    }
  }
}
</script>

<style scoped>
.workbench-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 28px;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #eef0f4;
}

.page-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.text-btn.redeem-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 14px;
  color: var(--primary);
  font-weight: 500;
}

.text-btn.redeem-btn:hover {
  background: #e3f2fd;
}

.promo-hot-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 14px 0 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
  background: linear-gradient(105deg, #ff5722 0%, #ff9800 48%, #ffb300 100%);
  box-shadow: 0 2px 10px rgba(255, 87, 34, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.promo-hot-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(255, 87, 34, 0.55);
}

.promo-fire {
  font-size: 16px;
  line-height: 1;
  animation: promo-fire-pulse 1.6s ease-in-out infinite;
}

.promo-hot-text {
  white-space: nowrap;
}

@keyframes promo-fire-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.12);
  }
}

.icon-btn {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  color: #6b7280;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn:hover {
  background: #f3f4f6;
  color: var(--primary);
}

.badge-dot {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
}

.user-menu {
  position: relative;
}

.user-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 10px 0 4px;
  border-radius: 999px;
  background: #f9fafb;
  border: 1px solid #eef0f4;
  max-width: 220px;
}

.user-trigger:hover {
  background: #f3f4f6;
}

.avatar-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-fallback {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.user-nick {
  font-size: 14px;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chevron {
  font-size: 12px;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.chevron.open {
  transform: rotate(180deg);
}

.dropdown-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 180px;
  padding: 6px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #eef0f4;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  z-index: 100;
}

.menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  color: var(--text-primary);
  text-align: left;
}

.menu-item i {
  color: #6b7280;
  font-size: 16px;
  flex-shrink: 0;
}

.menu-item-text {
  flex: 1;
}

.menu-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #1976d2;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}

.menu-item:hover {
  background: #f3f4f6;
}

.menu-item.danger {
  color: #ef4444;
}

.menu-item.danger i {
  color: #ef4444;
}

.menu-divider {
  height: 1px;
  margin: 4px 8px;
  background: #eef0f4;
}

.btn-primary.small {
  height: 34px;
  padding: 0 16px;
  font-size: 14px;
}

.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.menu-fade-enter,
.menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
